import { InputMaybe } from "src/generated/graphql";
import { Awards } from "./award";
import { Scalars } from "./scalars";
import { User } from "./user/user";
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

// Modelo de Item para BuyMov
export class BuyMovItem {
  id: Scalars["ID"];
  productId: Scalars["ID"];
  productName: Scalars["String"];
  quantity: Scalars["Int"];
  price: Scalars["Float"];
  total: Scalars["Float"];
  status: Scalars["String"];
}

// Modelo principal de BuyMov com itens
export class BuyMov {
  id: Scalars["ID"];
  name: Scalars["String"];
  quantity: Scalars["Int"];
  createdAt: Scalars["String"];
  status: Scalars["String"];
  buyDate: Scalars["String"];
  user: User;
  awards: Awards;
  phoneDelivery: Scalars["String"];
  employee: {
    re: string;
    name: string;
    email: string;
  };
  buyItems: BuyMovItem[]; // Verifique se esse campo está presente em vez de 'buyItems'
}

// ------------------- GETALL
export type GetAllBuyMovQueryVariables = Exact<{
  data: {
    re?: string;
    status?: string[];
    start?: Date;
    end?: Date;
  }
}>;

export type GetAllBuyMovQuery = { getAllBuyMov: BuyMov[] };

// ------------------- REMOVE
export class RemoveBuyMovInput {
  id: Scalars["ID"];
  role: Scalars["String"];
}

export type RemoveBuyMovMutationVariables = Exact<{
  buyMovId: string;
}>;

export type RemoveBuyMovMutation = {
  removeBuyMov: { id: string; role: string };
};

// ------------------- CREATE
export class CreateBuyMovItemInput {
  productId: Scalars["ID"];
  quantity: Scalars["Int"];
  price: Scalars["Float"];
  status: Scalars["String"];
}

export type CreateBuyMovMutationVariables = Exact<{
  data: {
    name: Scalars["String"];
    employee: { re: string; name: string; email: string };
    status: Scalars["String"];
    items: CreateBuyMovItemInput[];
  };
}>;

export type CreateBuyMovMutation = {
  createBuyMov: {
    id: string;
    name: string;
    items: {
      id: string;
      productId: string;
      productName: string;
      quantity: number;
      price: number;
      total: number;
    }[];
  };
};

// ------------------- UPDATE
export class UpdateBuyMovInput {
  id: string;
  data: {
    name: Scalars["String"];
    status: Scalars["String"];
    employee?: { re: string; name: string; email: string };
    items?: CreateBuyMovItemInput[];
  };
}

export type UpdateBuyMovMutation = {
  updateBuyMov: { id: string };
};

export type UpdateBuyMovMutationVariables = Exact<{
  id: string;
  data: UpdateBuyMovInput["data"];
}>;

// ------------------- SEARCH
export type SearchBuyMovQuery = Exact<{ searchBuyMov: BuyMov[] }>;

export class SearchBuyMovInput {
  re?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Array<Scalars["String"]>>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
  endDate?: InputMaybe<Scalars["DateTime"]>;
}

export type SearchBuyMovQueryVariables = Exact<{
  input: SearchBuyMovInput;
}>;

// ------------------- NOVO TIPO: CRIAR BuyMov COMPLETO
// Definição para o novo tipo de mutação, se necessário

export class CreateFullBuyMovInput {
  name: Scalars["String"];
  status: Scalars["String"];
  employee: { re: string; name: string; email: string };
  items: CreateBuyMovItemInput[];
  awards: Awards; // Dependendo de como 'Awards' é configurado, pode ser um array ou um objeto.
}

export type CreateFullBuyMovMutationVariables = Exact<{
  data: CreateFullBuyMovInput;
}>;

export type CreateFullBuyMovMutation = {
  createFullBuyMov: {
    id: string;
    name: string;
    status: string;
    items: {
      id: string;
      productId: string;
      productName: string;
      quantity: number;
      price: number;
      total: number;
    }[];
  };
};

export class DischargeBuyMovInput {
  id: Scalars["ID"];
  status: Scalars["String"];
}

export type DischargeBuyMovMutationVariables = Exact<{
  buyMovId: Scalars["ID"];
}>;
export type DischargeBuyMovMutation = {
  dischargeBuyMov: { id: string; status: string };
};

// ------------------- SEARCH
export type SearchBuyQuery = Exact<{ searchBuy: BuyMov[] }>;

export class SearchBuyInput {
  re?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Array<Scalars["String"]>>;
  start?: InputMaybe<Scalars["DateTime"]>;
  end?: InputMaybe<Scalars["DateTime"]>;
}

export type SearchBuyQueryVariables = Exact<{
  input: SearchBuyInput;
}>;
